module.exports = __webpack_public_path__ + "static/img/img_form1_ja.047c59b3.png";